<!-- DEAD COMPONENT -->
<template>
    <b-modal id="modal-change-duration"
             hide-footer
             centered
             :visible="isVisible"
             title="Laufzeit ändern"
             size="xl"
    >
        <div class="row">
            <div class="col-12">
                <div class="alert alert-warning">
                    Wir entscheiden individuell, ob eine Verländerung Deines Abos möglich ist.
                </div>
            </div>
            <div class="col-12 col-md-6">
                <dl class="row">
                    <dt class="col-6">Aktueller Monatspreis</dt>
                    <dd class="col-6">699,00 €</dd>
                    <dt class="col-6">Aktuelle Laufzeit</dt>
                    <dd class="col-6">6 Monate</dd>
                </dl>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <dl class="row">
                        <dt class="col-6"><b-form-radio v-model="duration" value="12">12 Monate</b-form-radio></dt>
                        <dd class="col-6">-200,00 €</dd>
                        <dt class="col-6"><b-form-radio v-model="duration" value="28">28 Monate</b-form-radio></dt>
                        <dd class="col-6">+250,00 €</dd>
                        <dt class="col-6"><b-form-radio v-model="duration" value="32">32 Monate</b-form-radio></dt>
                        <dd class="col-6">+300,00 €</dd>
                        <dt class="col-6"><b-form-radio v-model="duration" value="48">48 Monate</b-form-radio></dt>
                        <dd class="col-6">+736,00 €</dd>
                    </dl>
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-warning">
                    Änderung ab 12.12.2022 gültig.
                </div>
            </div>
        </div>
        <div class="row mt-3 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary mr-3" @click="abort">Schliessen</button>
            <button type="button" class="btn btn-primary mr-3" @click="close">Speichern</button>
        </div>
    </b-modal>
</template>

<script>
import { EventBus } from '../../event-bus';
import { BFormRadio, BModal } from 'bootstrap-vue';

export default {
    name: 'ModalChangeDuration',
    components: {
        BFormRadio, BModal
    },
    props: {},
    data() {
        return {
            isVisible: false,
            data: {},
            duration: null
        }
    },
    mounted() {
        EventBus.$on('init-change-duration', this.getData);
    },
    methods: {
        getData(data) {
            this.isVisible = true
            this.data = data
        },
        close(){
            this.isVisible = false
        },
        abort(){
            this.isVisible = false
        }
    },
    computed: {}
}
</script>